import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

export default function Divider({ className }: props) {
  return (
    <div className={classNames('Divider', 'uk-divider-icon', className)} />
  )
}

Divider.propTypes = {
  className: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/Divider/Divider.js